// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"247":"bfdd792f","362":"a500d9c4","422":"ad725247","517":"806da327","770":"f82ea768","982":"53fb7e16"}[chunkId] + ".chunk.css";
};